import {
  LabourUsageStateTypes,
  LabourUsageActionTypes,
} from "./LabourUsage.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: LabourUsageStateTypes = {
  fetchAll: resetApiCallState([]),
};

const LabourUsageReducer = (
  state: LabourUsageStateTypes = INITIAL_STATE,
  action: any
): LabourUsageStateTypes => {
  switch (action.type) {
    case LabourUsageActionTypes.FETCH_ALL_LABOUR_USAGE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case LabourUsageActionTypes.FETCH_ALL_LABOUR_USAGE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case LabourUsageActionTypes.FETCH_ALL_LABOUR_USAGE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case LabourUsageActionTypes.FETCH_ALL_LABOUR_USAGE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default LabourUsageReducer;
